import { AmountOption } from '@fhs/ui';

import { formatCentsToDollarString } from '../../utils/helpers';

export const ceilToNextFiveDollars = (amountCents: number) => {
  const fiveDollars = 500;
  return Math.ceil(amountCents / fiveDollars) * fiveDollars;
};

export const getReloadAmountOptions = (amountDueInCents: number): AmountOption[] => {
  const exact = amountDueInCents;
  const roundedUp = ceilToNextFiveDollars(amountDueInCents);
  const plus5 = roundedUp + 500;
  const plus10 = roundedUp + 1000;

  // Build unique list (handles cases where exact is already a multiple of $5)
  const uniqueValues = Array.from(new Set([exact, roundedUp, plus5, plus10]));

  return uniqueValues.map(cents => ({
    label: `$${formatCentsToDollarString(cents)}`,
    value: cents.toString(),
  }));
};
